import { render, staticRenderFns } from "./BriqDateTimePicker.vue?vue&type=template&id=21f8d20c&scoped=true&lang=pug&"
import script from "./BriqDateTimePicker.vue?vue&type=script&lang=js&"
export * from "./BriqDateTimePicker.vue?vue&type=script&lang=js&"
import style0 from "./BriqDateTimePicker.vue?vue&type=style&index=0&id=21f8d20c&lang=stylus&scoped=true&"
import style1 from "./BriqDateTimePicker.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8d20c",
  null
  
)

export default component.exports